enum Role {
  AGENT = "AGENT",
  QUERENT = "QUERENT",
  OWNER = "OWNER",
}

export default Role;